import React, { forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';

function withNavigate(Component) {
  const WrappedComponent = forwardRef((props, ref) => {
    const navigate = useNavigate();

    return (
      <Component
        {...props}
        navigate={navigate}
        ref={ref}
      />
    );
  });

  WrappedComponent.displayName = `withNavigate(${Component.displayName || Component.name})`;
  return WrappedComponent;
}

export default withNavigate;
